export const driveCreativesCopy = {
  passo: "pasta do Drive",
  lugar: "Pasta do Google Drive",
  link: {
    semConta: "Para abrir o link do Drive desta conversa, a Nabla precisa de uma conta Google da empresa que veja o arquivo ou a pasta. " +
      "Conectada a conta, só para ler, a Nabla continua o pedido daqui.",
    fechado: (email: string) => `A conta Google da empresa, ${email}, não abre o link do Drive desta conversa. ` +
      "Compartilhe o arquivo ou a pasta com ela, como Leitor, e peça de novo.",
    agora: (email: string) => `A conta Google da empresa, ${email}, está conectada: a Nabla abre o link por ela.`,
    instalada: "A chave do Drive instalada para esta empresa não abre o link desta conversa. " +
      "Compartilhe o arquivo ou a pasta com ela, como Leitor, e peça de novo.",
    endereco: (email: string) => `Ou compartilhe o arquivo ou a pasta, como Leitor, com o endereço da Nabla desta empresa: ${email}.`,
    sem: "Esta instalação da Nabla ainda não conecta contas Google. Peça a quem cuida da instalação.",
    troca: (email: string, pasta?: string) => `A conta Google da empresa, ${email}, parou de responder, então a Nabla não abre o link ` +
      "desta conversa. Conectar uma conta aqui troca a conta da empresa" +
      (pasta === undefined ? "." : ` e desconecta a pasta padrão, ${pasta}, até alguém conectá-la de novo pela nova conta.`),
    trocar: "Trocar a conta Google da empresa",
  },
} as const;
